import { GrowthBook } from "@growthbook/growthbook";
import Vue from "vue";

const attributes = Vue.observable({
  email: null,
});

const gbInstance = new GrowthBook({
  clientKey: process.env.VUE_APP_GROWTHBOOK_KEY,
  attributes: {
    // Add user attributes here
  },
  enableDevMode: process.env.NODE_ENV === "development",
});

export default async function initializeGrowthBook() {
  try {
    await gbInstance.init({ streaming: true });

    const defaultSetAttributes = gbInstance.setAttributes;

    gbInstance.setAttributes = (attrs) => {
      attributes.email = attrs?.email;
      defaultSetAttributes.call(gbInstance, attrs);
    };

    attributes.email = gbInstance.context.attributes.email;
    gbInstance.attributes = attributes;

    return gbInstance;
  } catch (e) {
    console.error("Error initializing GrowthBook:", e);
    return null;
  }
}
